import styled from 'styled-components';

const StyledTimelineTabs = styled.div`
  position: relative;
  width: 100%;
  overflow: auto;
  .slider-tabs{
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .num{
    position: relative;
    cursor: pointer;
    padding-right: 80px;
    margin-right: 24px;
    color: ${props => props.theme.colors.grey_700};
    transition: all .25s ease-out;
    p{
      padding-bottom: 16px;
    }
    .tab--line{
      position: absolute;
      bottom: 0;
      left: 0;
      height: 8px;
      display: block;
      background: ${props => props.theme.colors.green_secondary} ;
      width: 0;
      transition: width 1s;
    }
    &.selected{
      padding-right: 480px;
      color: ${props => props.theme.colors.green_secondary};
      .tab--line{
        width: 100%;
      }
    }
  }
  @media screen and (max-width: 1439px){
    .num{
      &.selected{
        padding-right: 325px;
      }
    }
  }
  @media screen and (max-width: 1023px){
    .num{
      padding-right: 64px;
      margin-right: 16px;
      &.selected{
        padding-right: 235px;
      }
    }
  }
  @media screen and (max-width: 767px){
    .num{
      padding-right: 24px;
      &.selected{
        padding-right: 70px;
      }
      p{
        padding-bottom: 8px;
      }
      .tab--line{
        height: 4px;
      }
    }
  }
`;

export {
  StyledTimelineTabs,
};

